import React, {useEffect} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {
  FiAlertTriangle,
  FiCheckCircle,
  FiInfo,
  FiX,
  FiXCircle
} = FiIcons;

const toneConfig = {
  success: {
    icon: FiCheckCircle,
    border: 'border-l-4 border-l-emerald-500',
    iconColor: 'text-emerald-600',
    label: 'Success'
  },
  error: {
    icon: FiXCircle,
    border: 'border-l-4 border-l-red-500',
    iconColor: 'text-red-600',
    label: 'Error'
  },
  warning: {
    icon: FiAlertTriangle,
    border: 'border-l-4 border-l-amber-500',
    iconColor: 'text-amber-600',
    label: 'Warning'
  },
  info: {
    icon: FiInfo,
    border: 'border-l-4 border-l-teal-500',
    iconColor: 'text-teal-600',
    label: 'Information'
  }
};

function Toast({
  message,
  type = 'success',
  onClose,
  duration = 4000
}) {
  const config = toneConfig[type] || toneConfig.info;

  useEffect(() => {
    if (!message || !onClose) {
      return undefined;
    }

    const timeoutId = window.setTimeout(onClose, duration);

    return () => window.clearTimeout(timeoutId);
  }, [message, onClose, duration]);

  if (!message) {
    return null;
  }

  return (
    <div
      className={`fixed right-4 top-4 z-[70] flex w-[calc(100%-2rem)] max-w-sm animate-slide-in-right items-start gap-3 rounded-xl border border-gray-100 bg-white p-4 shadow-xl ${config.border}`}
      role="status"
      aria-live="polite"
    >
      <SafeIcon
        icon={config.icon}
        className={`mt-0.5 h-5 w-5 shrink-0 ${config.iconColor}`}
      />

      <p className="min-w-0 flex-1 text-sm font-medium leading-5 text-gray-700">
        {message}
      </p>

      <button
        type="button"
        aria-label={`Close ${config.label.toLowerCase()} notification`}
        onClick={onClose}
        className="rounded-md p-1 text-gray-400 transition-colors hover:bg-gray-50 hover:text-gray-700"
      >
        <SafeIcon icon={FiX} className="h-4 w-4" />
      </button>
    </div>
  );
}

export default Toast;